import React from "react";
import { VoiceCloneCreatorOptions } from "../base/VoiceCloneSynthesis";
import { MISSION_CONFIG } from "./missionConfig";

function MissionVoice(props) {
  return (
    <VoiceCloneCreatorOptions
      {...props}
      workshopConfig={MISSION_CONFIG.voice}
    />
  );
}

export { MissionVoice };
